import { render, staticRenderFns } from "./SmsDialog.vue?vue&type=template&id=0ada873c&scoped=true"
import script from "./SmsDialog.vue?vue&type=script&lang=js"
export * from "./SmsDialog.vue?vue&type=script&lang=js"
import style0 from "./SmsDialog.vue?vue&type=style&index=0&id=0ada873c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada873c",
  null
  
)

export default component.exports